// Module
var code = `<div class="chart-order-entry" style="{{#if !.visible}}display:none;{{/if}}">
    <div class="advanced-chart-order-entry">
        <OEQuantity name="qtyNumeric"
                    validationStateInfo="{{.numericsErrors.n1}}"
                    showLabel="false"
                    account="{{accountItem}}"
                    instrument="{{instrumentItem}}"
                    quantity="{{quantity}}" />
                
        {{#if .isVisibleOTHTrading}}
            <overnightExecutionControlRactive isActive="{{isAllowOTHTrading}}" 
                                            textKey="{{overnightExecutionTextKey}}" 
                                            tooltipKey="{{isAllowOTHTrading ? overnightExecutionTooltipKeyActive : overnightExecutionTooltipKeyInActive}}" 
                                            events="{{isAllowOTHTradingEvents}}"/>
        {{/if}}

        <terceraSLTPNumeric isSL="true"
                            SLTPChecked="{{.enabledSL}}"
                            value="{{.priceSL}}"
                            minValue="{{.minSLPrice}}"
                            maxValue="{{.maxSLPrice}}"
                            step="{{.slNumericStep}}"
                            decimalPrecision="{{.slNumericPrecision}}"
                            validationStateInfo="{{.numericsErrors.n6}}"
                            forChart="true"
                            trStopVisible="{{.trStopAllowed}}"
                            trStopChecked="{{.trStopChecked}}"
                            visible="{{.isSlVisible}}" 
                            rightAlignedText="{{.slNumericRightAlignedText}}"
                            rightAlignedTextAdditionalClass="watermark"
                            instrument="{{instrumentItem}}"/>

        <terceraNumeric tooltip="{{.sllLabelTooltip}}"
                        visible="{{.isSLLVisible}}"
                        enabled="{{!.trStopChecked}}"
                        value="{{priceSLL}}"
                        minValue="{{.minSLLPrice}}"
                        maxValue="{{.maxSLPrice}}"
                        decimalPrecision="{{.slNumericPrecision}}"
                        step="{{.slNumericStep}}"
                        name="sllNumeric" />

        <terceraSLTPNumeric SLTPChecked="{{.enabledTP}}"
                            value="{{.priceTP}}"
                            minValue="{{.minTPPrice}}"
                            maxValue="{{.maxTPPrice}}"
                            step="{{.tpNumericStep}}"
                            decimalPrecision="{{.tpNumericPrecision}}"
                            validationStateInfo="{{.numericsErrors.n7}}"
                            forChart="true"
                            visible="{{.isTPVisible}}" 
                            rightAlignedText="{{.tpNumericRightAlignedText}}"
                            rightAlignedTextAdditionalClass="watermark"
                            instrument="{{instrumentItem}}"/>

        <OEProductTypeSelector showLabel="false"
                               instrument="{{instrumentItem}}"
                               account="{{accountItem}}"
                               productType="{{productType}}" />

        <terceraTIFComboBox orderType="{{orderTypeId}}"
                            instrument="{{instrumentItem}}"
                            items="{{items}}"
                            selectedItem="{{selectedItem}}"
                            gtdDate="{{gtdDate}}" />

        <OELeverageSelector showLabel="false"
                            instrument="{{instrumentItem}}"
                            account="{{accountItem}}"
                            productType="{{productType}}"
                            leverageValue="{{leverageValue}}" />
    </div>

    <div class="advanced-chart-order-entry-btn">
        {{#if .reverseButtons}}
            {{>chartSellButtons}}
            {{>chartBuyButtons}}
        {{else}}
            {{>chartBuyButtons}}
            {{>chartSellButtons}}
        {{/if}}
    </div>
</div>`;
// Exports
export default code;